import {setGetUsersAction} from '../action';
import { getUsersInCsv } from '../api/getUsersInCsv';

export const setGetUsersInCsv = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getUsersInCsv(params);

            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'data.csv'); // Имя файла для загрузки
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}